import React, { useEffect, useState, useRef } from 'react';

import { Button } from 'apps/auth/components/common/Button/Button';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import InputDropBox from 'apps/auth/components/form/InputDropBox';
import Form from 'apps/auth/components/form-multi/Form';
import TextPopup from 'apps/auth/components/sharedComponents/popups/TextPopup';
import { PROFILE_USA_OCCUPATION } from 'apps/auth/constants/formName';
import { AUTH_PROFILE_CHANGE_US_OCCUPATION_ACTION } from 'apps/auth/constants/UrlConstants';
import { useFields, usePageMessages } from 'apps/auth/hooks/selectors';

const OccupationScreen = (props) => {
    const [isDisabledButton, setDisabled] = useState(true);
    const popupRef = useRef(null);
    const { occupationHeader, buttonContinue, gotIt } = usePageMessages();
    const { occupation } = useFields(PROFILE_USA_OCCUPATION);

    useEffect(() => {
        setDisabled(!occupation?.value);
    }, [occupation?.value]);

    const errorHandler = (error) => {
        popupRef.current?.open(<TextPopup text={error?.text} buttonText={gotIt} popupRef={popupRef} />);
    };

    return (
        <>
            <HeaderPanel title={occupationHeader} />
            <Form
                formName={PROFILE_USA_OCCUPATION}
                action={AUTH_PROFILE_CHANGE_US_OCCUPATION_ACTION}
                onSubmitHandler={props.onSubmitHandler}
                onErrorHandler={errorHandler}
            >
                <Row indent="adaptive-32-48">
                    <InputDropBox formName={PROFILE_USA_OCCUPATION} field={occupation} />
                </Row>
                <FixedBottomPanel isRightAligned>
                    <Button type="submit" caption={buttonContinue} disabled={isDisabledButton} />
                </FixedBottomPanel>
            </Form>
            <PopupNew ref={popupRef} />
        </>
    );
};
export default OccupationScreen;
